import React, { useState } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { DEFAULT_ONBOARDING_COUNTRIES, ONBOARDING_COUNTRY_CODES } from './onboardingCountryPreferences'
import { formatCountry } from './onboardingFunnelUtils'

const countryOptions = ONBOARDING_COUNTRY_CODES.map(code => ({ code, label: formatCountry(code) }))
    .sort((left, right) => left.label.localeCompare(right.label, 'ko'))

// 온보딩 퍼널과 국가별 지표가 같은 편집기를 쓴다.
// 기본 목록과 안내 문구만 화면마다 달라서 prop으로 열어두고, 값을 안 넘기면
// 온보딩 기준으로 동작한다(기존 호출부는 그대로).
export default function OnboardingCountryFilterEditor({
    countries,
    onSave,
    defaultCountries = DEFAULT_ONBOARDING_COUNTRIES,
    description = '필터에 표시할 국가를 선택하세요. 전체·기타는 항상 표시되며, 선택한 목록은 이 브라우저에 저장됩니다.',
}) {
    const [open, setOpen] = useState(false)
    const [draft, setDraft] = useState([])

    return (
        <>
            <Button size="small" variant="outlined" onClick={() => {
                setDraft([...countries])
                setOpen(true)
            }}>국가 필터 편집</Button>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" aria-labelledby="country-filter-editor-title">
                <DialogTitle id="country-filter-editor-title">국가 필터 편집</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {description}
                    </Typography>
                    <Autocomplete
                        multiple
                        disableCloseOnSelect
                        options={countryOptions}
                        value={draft.map(code => countryOptions.find(option => option.code === code)).filter(Boolean)}
                        onChange={(_event, values) => setDraft(values.map(value => value.code))}
                        getOptionLabel={option => `${option.label} (${option.code})`}
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <Checkbox checked={selected} tabIndex={-1} sx={{ mr: 1 }} />
                                {option.label} ({option.code})
                            </li>
                        )}
                        renderInput={params => <TextField {...params} label="표시할 국가" placeholder="국가명 또는 국가 코드 검색" />}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDraft([...defaultCountries])} sx={{ mr: 'auto' }}>기본 목록 복원</Button>
                    <Button onClick={() => setOpen(false)}>취소</Button>
                    <Button variant="contained" onClick={() => {
                        onSave(draft)
                        setOpen(false)
                    }}>저장</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
